import AppComponent from '../base/app-component.ts';

const TEMA_CSS_MAP: Record<string, string> = {
  default: '/static/css/style.css',
  azure: '/static/css/style-azure.css',
  dark: '/static/css/style-dark.css',
};

declare const currentUser: { tema?: string } | undefined;

export class TemaSelector extends AppComponent {
  static override componentName = 'wc-tema-selector';

  protected override get templateId() { return 'tema-selector'; }

  private get isCompact(): boolean {
    return this.hasAttribute('compact');
  }

  protected override buildRenderingData(): Record<string, unknown> {
    return {
      ...super.buildRenderingData(),
      temaCorrente: currentUser?.tema ?? 'default',
      compact: this.isCompact,
    };
  }

  protected override afterRender(): void {
    if (this.isCompact) {
      this.delegate.on<MouseEvent>('click', '[data-action="change-tema"]', (e) => {
        const btn = (e.target as HTMLElement).closest('[data-value]') as HTMLElement | null;
        if (btn) this.changeTema(btn.dataset.value!);
      });
    } else {
      this.delegate.on<Event>('change', '[data-action="change-tema"]', (e) => {
        const radio = e.target as HTMLInputElement;
        this.changeTema(radio.value);
      });
    }
  }

  private async changeTema(tema: string): Promise<void> {
    const link = document.getElementById('theme-css') as HTMLLinkElement | null;
    if (link) {
      const version = link.href.split('?v=')[1] ?? '';
      link.href = `${TEMA_CSS_MAP[tema] ?? TEMA_CSS_MAP.default}?v=${version}`;
    }

    // Aggiorna lo stato attivo su tutti i tema-selector nella pagina
    for (const selector of document.querySelectorAll('wc-tema-selector')) {
      for (const btn of selector.querySelectorAll('[data-action="change-tema"]')) {
        if (btn instanceof HTMLButtonElement) {
          const isActive = btn.dataset.value === tema;
          btn.classList.toggle('btn-primary', isActive);
          btn.classList.toggle('btn-outline-secondary', !isActive);
        } else if (btn instanceof HTMLInputElement) {
          btn.checked = btn.value === tema;
        }
      }
    }

    try {
      await fetch('/auth/tema', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ tema }),
      });
    } catch {
      Weext.toast('Errore nel salvataggio del tema', { type: 'danger' });
    }
  }
}
